"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.factory("$throttle", function ($timeout, $now, $rootScope) {
  /**
   * @ngdoc service
   * @name $throttle
   *
   * @description
   * Angular's $timeout wrapper around the 'throttle' approach (such as in underscore).
   * By default, throttle will execute the function as soon as you call it for the first time,
   * and, if you call it again any number of times during the wait period, as soon as that period is over.
   * If you'd like to disable the leading-edge call, pass {leading: false},
   * and if you'd like to disable the execution on the trailing-edge, pass {trailing: false}.
   *
   * @param {function()} fn A function to debounce.
   * @param {number}  delay The throttle duration in milliseconds.
   * @param {boolean=} [invokeApply=true] If set to 'false', skips the {@link ng.$rootScope.Scope#$apply `$applỳ} call.
   * @param {Object=} [options={}]
   *
   * @returns {function()} The throttled function wrapper.
   */
  function $throttle(fn, delay, invokeApply, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    var initial = true;
    if (arguments.length === 3 && _.isObject(invokeApply)) {
      options = invokeApply;
      invokeApply = true;
    }
    if (!options) {
      options = {};
    }
    var later = function later() {
      previous = options.leading === false ? 0 : $now();
      timeout = null;
      result = fn.apply(context, args);
      if (!timeout) {
        context = args = null;
      }
    };
    return function throttleWrapper() {
      var now = $now();
      if (!previous && options.leading === false) {
        previous = now;
        initial = false;
      }
      var remaining = delay - (now - previous);
      context = this;
      args = arguments;
      if (initial === true || remaining <= 0 || remaining > delay) {
        if (timeout) {
          $timeout.cancel(timeout);
          timeout = null;
        }
        previous = now;
        initial = false;
        result = fn.apply(context, args);
        if (invokeApply !== false) {
          $rootScope.$apply();
        }
        if (!timeout) {
          context = args = null;
        }
      } else if (!timeout && options.trailing !== false) {
        timeout = $timeout(later, remaining, invokeApply);
      }
      return result;
    };
  }
  return $throttle;
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/$throttle.js
// module id = 2742
// module chunks = 13